/**
 * @flow
 */

import React from 'react';
import Config from 'config';
import { withRouter } from 'react-router-dom';
import { getItem } from '../lib/local-storage';

type Props = {
  listing: ListingRecord;
  user: AnyMap;
  location: AnyMap;
  pageData: Object;
};

class DigitalData extends React.Component<void, Props, void> {
  constructor(props: Props) {
    super(props);

    this.setDigitalData(props);
  }

  componentDidMount() {
    if (window.dataLayer && (window.dataLayer.push instanceof Function)) {
      window.dataLayer.push({ event: 'virtualPageView' });
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setDigitalData(nextProps);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (window.dataLayer && (window.dataLayer.push instanceof Function)) {
        window.dataLayer.push({ event: 'virtualPageView' });
      }
    }
  }

  render() {
    return null;
  }

  setDigitalData(props: Props) {
    try {
      const { listing, user, pageData } = props;

      let page = {};
      if (listing) {
        page = this.listingPageData(listing);
      }
      else if (user) {
        page = this.userPageData(user);
      }
      else {
        page = this.defaultPageData(pageData);
      }

      if (page.pageInfo && Config.environment !== 'production') {
        page.pageInfo['isTestEntity'] = '1';
      }

      const digitalData = {
        page,
        cart: {},
        transaction: {}
      };

      window.digitalData = digitalData;
    }
    catch (e) {
      /* eslint-disable no-console */
      console.log('Error', e);
      /* eslint-enable no-console */
    }
  }

  listingPageData(listing: ListingRecord): Object {
    const data: Object = {
      pageInfo: {
        destinationURL: `${Config.api.host}/events/${listing.getIn(['listing', 'slug'])}`,
        domain: `UNI_${listing.getIn(['listing', 'country_code'])}`,
        platform: 'enterprise',
        publisher: 'universe',
        publisherDivision: listing.getIn(['listing', 'country_code']),
        environment: Config.environment,
        Experience: '',
        pageChannel: 'event-display-page',
        pageType: 'Event Display Page',
        pageName: `UNI_${listing.getIn(['listing', 'country_code'])}: Event Display Page`,
        referringURL: getItem('referringURL'),
      },
      category: {
        organization: 'UN',
        primaryCategory: listing.getIn(['listing', 'category_key']),
        primaryCategoryID: listing.getIn(['listing', 'category_id']),
      },
      attributes: {
        eventName: listing.getIn(['listing', 'title']),
        state: listing.getIn(['listing', 'province']),
        city: listing.getIn(['listing', 'city']),
        universeHostID: listing.getIn(['listing', 'host_id']),
        universeHostName: listing.getIn(['listing', 'host_name']),
        discovery: {}
      }
    };

    if (listing.getIn(['listing', 'ticketmaster_attraction_ids']).length > 0) {
      data.attributes.discovery.attraction = listing.getIn(['ticketmaster_attraction_ids']).map(id => {
        return {
          id
        };
      });
    }

    if (listing.getIn(['listing', 'ticketmaster_venue_id'])) {
      data.attributes.discovery.venue = [{
        id: listing.getIn(['listing', 'ticketmaster_venue_id']),
        name: listing.getIn(['listing', 'ticketmaster_venue_name']),
        address: listing.getIn(['listing', 'location']),
        stateCode: listing.getIn(['listing', 'province']),
        city: listing.getIn(['listing', 'city']),
        countryCode: listing.getIn(['listing', 'country_code'])
      }];
    }

    return data;
  }

  userPageData(user: AnyMap): Object {
    const data: Object = {
      pageInfo: {
        destinationURL: user.url,
        domain: 'UNI_CA',
        platform: 'enterprise',
        publisher: 'universe',
        publisherDivision: 'CA',
        environment: Config.environment,
        Experience: '',
        pageChannel: 'profile-display-page',
        pageType: 'Profile Display Page',
        pageName: 'UNI_CA: Profile Display Page',
        referringURL: getItem('referringURL'),
      },
      attributes: {
        universeHostID: user.id,
        universeHostName: user.name,
        discovery: {}
      }
    };

    return data;
  }

  defaultPageData(pageData: Object = { channel: this.pathnameToChannel(), type: this.pathnameToType() }): Object {
    const { channel, type } = pageData;
    const data: Object = {
      pageInfo: {
        Experience: '',
        destinationURL: window.location.href,
        domain: 'UNI_CA',
        environment: Config.environment,
        isTestEntity: Config.environment === 'production' ? 0 : 1,
        pageChannel: channel,
        pageName: `UNI_CA: ${type}`,
        pageType: type,
        platform: 'enterprise',
        publisher: 'universe',
        publisherDivision: 'CA',
        referringURL: getItem('referringURL'),
      }
    };
    return data;
  }

  pathnameToChannel(): string {
    return location.pathname.split('/').filter(Boolean).join('_');
  }

  pathnameToType(): string {
    return location.pathname.split('/').filter(Boolean).join(' ');
  }
}

export default withRouter(DigitalData);



// WEBPACK FOOTER //
// ./src/components/digital-data.js